import { render, staticRenderFns } from "./taolimenulist.vue?vue&type=template&id=4b24b724&scoped=true&"
import script from "./taolimenulist.vue?vue&type=script&lang=js&"
export * from "./taolimenulist.vue?vue&type=script&lang=js&"
import style0 from "./taolimenulist.vue?vue&type=style&index=0&id=4b24b724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b24b724",
  null
  
)

export default component.exports